import { render, staticRenderFns } from "./GestioneMovimenti.vue?vue&type=template&id=3b5ff192&"
import script from "./GestioneMovimenti.vue?vue&type=script&lang=js&"
export * from "./GestioneMovimenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports